import { render, staticRenderFns } from "./BannersList.vue?vue&type=template&id=1a5c28f8"
import script from "./BannersList.vue?vue&type=script&lang=js"
export * from "./BannersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports